// removed by extract-text-webpack-plugin
module.exports = {"callout":"_1IUvJbReshQ1aH8u8yNTby"};


//////////////////
// WEBPACK FOOTER
// ./src/features/Callout/callout.module.styl
// module id = 245
// module chunks = 213534597649335 259173521737895